import ValueSet, { Coding } from '../ValueSet';

const uspsStates = new ValueSet(
  'http://hl7.org/fhir/ValueSet/usps-state',
  'USPS States',
  'survey-list',
  [
    new Coding('AK', 'Alaska', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('AL', 'Alabama', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('AR', 'Arkansas', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'AS',
      'American Samoa',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('AZ', 'Arizona', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'CA',
      'California',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('CO', 'Colorado', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'CT',
      'Connecticut',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'DC',
      'District of Columbia',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('DE', 'Delaware', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('FL', 'Florida', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'FM',
      'Federated States of Micronesia',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('GA', 'Georgia', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('GU', 'Guam', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('HI', 'Hawaii', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('IA', 'Iowa', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('ID', 'Idaho', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('IL', 'Illinois', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('IN', 'Indiana', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('KS', 'Kansas', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('KY', 'Kentucky', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('LA', 'Louisiana', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'MA',
      'Massachusetts',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('MD', 'Maryland', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('ME', 'Maine', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'MH',
      'Marshall Islands',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('MI', 'Michigan', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('MN', 'Minnesota', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('MO', 'Missouri', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'MP',
      'Northern Mariana Islands',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'MS',
      'Mississippi',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('MT', 'Montana', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'NC',
      'North Carolina',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'ND',
      'North Dakota',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('NE', 'Nebraska', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'NH',
      'New Hampshire',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'NJ',
      'New Jersey',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'NM',
      'New Mexico',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('NV', 'Nevada', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('NY', 'New York', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('OH', 'Ohio', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('OK', 'Oklahoma', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('OR', 'Oregon', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'PA',
      'Pennsylvania',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'PR',
      'Puerto Rico',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('PW', 'Palau', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'RI',
      'Rhode Island',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'SC',
      'South Carolina',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding(
      'SD',
      'South Dakota',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('TN', 'Tennessee', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('TX', 'Texas', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'UM',
      'U.S. Minor Outlying Islands',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('UT', 'Utah', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding('VA', 'Virginia', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'VI',
      'Virgin Islands of the U.S.',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('VT', 'Vermont', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'WA',
      'Washington',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('WI', 'Wisconsin', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
    new Coding(
      'WV',
      'West Virginia',
      'http://hl7.org/fhir/ValueSet/usps-state',
      0,
    ),
    new Coding('WY', 'Wyoming', 'http://hl7.org/fhir/ValueSet/usps-state', 0),
  ],
);

const iso3166CountryCodes = new ValueSet(
  'urn:iso:std:iso:3166',
  'Country Codes',
  'survey-list',
  [
    new Coding('AD', 'Andorra', 'urn:iso:std:iso:3166', 0),
    new Coding('AE', 'United Arab Emirates', 'urn:iso:std:iso:3166', 0),
    new Coding('AF', 'Afghanistan', 'urn:iso:std:iso:3166', 0),
    new Coding('AG', 'Antigua and Barbuda', 'urn:iso:std:iso:3166', 0),
    new Coding('AI', 'Anguilla', 'urn:iso:std:iso:3166', 0),
    new Coding('AL', 'Albania', 'urn:iso:std:iso:3166', 0),
    new Coding('AM', 'Armenia', 'urn:iso:std:iso:3166', 0),
    new Coding('AO', 'Angola', 'urn:iso:std:iso:3166', 0),
    new Coding('AQ', 'Antarctica', 'urn:iso:std:iso:3166', 0),
    new Coding('AR', 'Argentina', 'urn:iso:std:iso:3166', 0),
    new Coding('AS', 'American Samoa', 'urn:iso:std:iso:3166', 0),
    new Coding('AT', 'Austria', 'urn:iso:std:iso:3166', 0),
    new Coding('AU', 'Australia', 'urn:iso:std:iso:3166', 0),
    new Coding('AW', 'Aruba', 'urn:iso:std:iso:3166', 0),
    new Coding('AX', 'Åland Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('AZ', 'Azerbaijan', 'urn:iso:std:iso:3166', 0),
    new Coding('BA', 'Bosnia and Herzegovina', 'urn:iso:std:iso:3166', 0),
    new Coding('BB', 'Barbados', 'urn:iso:std:iso:3166', 0),
    new Coding('BD', 'Bangladesh', 'urn:iso:std:iso:3166', 0),
    new Coding('BE', 'Belgium', 'urn:iso:std:iso:3166', 0),
    new Coding('BF', 'Burkina Faso', 'urn:iso:std:iso:3166', 0),
    new Coding('BG', 'Bulgaria', 'urn:iso:std:iso:3166', 0),
    new Coding('BH', 'Bahrain', 'urn:iso:std:iso:3166', 0),
    new Coding('BI', 'Burundi', 'urn:iso:std:iso:3166', 0),
    new Coding('BJ', 'Benin', 'urn:iso:std:iso:3166', 0),
    new Coding('BL', 'Saint Barthélemy', 'urn:iso:std:iso:3166', 0),
    new Coding('BM', 'Bermuda', 'urn:iso:std:iso:3166', 0),
    new Coding('BN', 'Brunei Darussalam', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'BO',
      'Bolivia (Plurinational State of)',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding(
      'BQ',
      'Bonaire, Sint Eustatius and Saba',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('BR', 'Brazil', 'urn:iso:std:iso:3166', 0),
    new Coding('BS', 'Bahamas', 'urn:iso:std:iso:3166', 0),
    new Coding('BT', 'Bhutan', 'urn:iso:std:iso:3166', 0),
    new Coding('BV', 'Bouvet Island', 'urn:iso:std:iso:3166', 0),
    new Coding('BW', 'Botswana', 'urn:iso:std:iso:3166', 0),
    new Coding('BY', 'Belarus', 'urn:iso:std:iso:3166', 0),
    new Coding('BZ', 'Belize', 'urn:iso:std:iso:3166', 0),
    new Coding('CA', 'Canada', 'urn:iso:std:iso:3166', 0),
    new Coding('CC', 'Cocos (Keeling) Islands', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'CD',
      'Congo, Democratic Republic of the',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('CF', 'Central African Republic', 'urn:iso:std:iso:3166', 0),
    new Coding('CG', 'Congo', 'urn:iso:std:iso:3166', 0),
    new Coding('CH', 'Switzerland', 'urn:iso:std:iso:3166', 0),
    new Coding('CI', "Côte d'Ivoire", 'urn:iso:std:iso:3166', 0),
    new Coding('CK', 'Cook Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('CL', 'Chile', 'urn:iso:std:iso:3166', 0),
    new Coding('CM', 'Cameroon', 'urn:iso:std:iso:3166', 0),
    new Coding('CN', 'China', 'urn:iso:std:iso:3166', 0),
    new Coding('CO', 'Colombia', 'urn:iso:std:iso:3166', 0),
    new Coding('CR', 'Costa Rica', 'urn:iso:std:iso:3166', 0),
    new Coding('CU', 'Cuba', 'urn:iso:std:iso:3166', 0),
    new Coding('CV', 'Cabo Verde', 'urn:iso:std:iso:3166', 0),
    new Coding('CW', 'Curaçao', 'urn:iso:std:iso:3166', 0),
    new Coding('CX', 'Christmas Island', 'urn:iso:std:iso:3166', 0),
    new Coding('CY', 'Cyprus', 'urn:iso:std:iso:3166', 0),
    new Coding('CZ', 'Czechia', 'urn:iso:std:iso:3166', 0),
    new Coding('DE', 'Germany', 'urn:iso:std:iso:3166', 0),
    new Coding('DJ', 'Djibouti', 'urn:iso:std:iso:3166', 0),
    new Coding('DK', 'Denmark', 'urn:iso:std:iso:3166', 0),
    new Coding('DM', 'Dominica', 'urn:iso:std:iso:3166', 0),
    new Coding('DO', 'Dominican Republic', 'urn:iso:std:iso:3166', 0),
    new Coding('DZ', 'Algeria', 'urn:iso:std:iso:3166', 0),
    new Coding('EC', 'Ecuador', 'urn:iso:std:iso:3166', 0),
    new Coding('EE', 'Estonia', 'urn:iso:std:iso:3166', 0),
    new Coding('EG', 'Egypt', 'urn:iso:std:iso:3166', 0),
    new Coding('EH', 'Western Sahara', 'urn:iso:std:iso:3166', 0),
    new Coding('ER', 'Eritrea', 'urn:iso:std:iso:3166', 0),
    new Coding('ES', 'Spain', 'urn:iso:std:iso:3166', 0),
    new Coding('ET', 'Ethiopia', 'urn:iso:std:iso:3166', 0),
    new Coding('FI', 'Finland', 'urn:iso:std:iso:3166', 0),
    new Coding('FJ', 'Fiji', 'urn:iso:std:iso:3166', 0),
    new Coding('FK', 'Falkland Islands (Malvinas)', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'FM',
      'Micronesia (Federated States of)',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('FO', 'Faroe Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('FR', 'France', 'urn:iso:std:iso:3166', 0),
    new Coding('GA', 'Gabon', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'GB',
      'United Kingdom of Great Britain and Northern Ireland',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('GD', 'Grenada', 'urn:iso:std:iso:3166', 0),
    new Coding('GE', 'Georgia', 'urn:iso:std:iso:3166', 0),
    new Coding('GF', 'French Guiana', 'urn:iso:std:iso:3166', 0),
    new Coding('GG', 'Guernsey', 'urn:iso:std:iso:3166', 0),
    new Coding('GH', 'Ghana', 'urn:iso:std:iso:3166', 0),
    new Coding('GI', 'Gibraltar', 'urn:iso:std:iso:3166', 0),
    new Coding('GL', 'Greenland', 'urn:iso:std:iso:3166', 0),
    new Coding('GM', 'Gambia', 'urn:iso:std:iso:3166', 0),
    new Coding('GN', 'Guinea', 'urn:iso:std:iso:3166', 0),
    new Coding('GP', 'Guadeloupe', 'urn:iso:std:iso:3166', 0),
    new Coding('GQ', 'Equatorial Guinea', 'urn:iso:std:iso:3166', 0),
    new Coding('GR', 'Greece', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'GS',
      'South Georgia and the South Sandwich Islands',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('GT', 'Guatemala', 'urn:iso:std:iso:3166', 0),
    new Coding('GU', 'Guam', 'urn:iso:std:iso:3166', 0),
    new Coding('GW', 'Guinea-Bissau', 'urn:iso:std:iso:3166', 0),
    new Coding('GY', 'Guyana', 'urn:iso:std:iso:3166', 0),
    new Coding('HK', 'Hong Kong', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'HM',
      'Heard Island and McDonald Islands',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('HN', 'Honduras', 'urn:iso:std:iso:3166', 0),
    new Coding('HR', 'Croatia', 'urn:iso:std:iso:3166', 0),
    new Coding('HT', 'Haiti', 'urn:iso:std:iso:3166', 0),
    new Coding('HU', 'Hungary', 'urn:iso:std:iso:3166', 0),
    new Coding('ID', 'Indonesia', 'urn:iso:std:iso:3166', 0),
    new Coding('IE', 'Ireland', 'urn:iso:std:iso:3166', 0),
    new Coding('IL', 'Israel', 'urn:iso:std:iso:3166', 0),
    new Coding('IM', 'Isle of Man', 'urn:iso:std:iso:3166', 0),
    new Coding('IN', 'India', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'IO',
      'British Indian Ocean Territory',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('IQ', 'Iraq', 'urn:iso:std:iso:3166', 0),
    new Coding('IR', 'Iran (Islamic Republic of)', 'urn:iso:std:iso:3166', 0),
    new Coding('IS', 'Iceland', 'urn:iso:std:iso:3166', 0),
    new Coding('IT', 'Italy', 'urn:iso:std:iso:3166', 0),
    new Coding('JE', 'Jersey', 'urn:iso:std:iso:3166', 0),
    new Coding('JM', 'Jamaica', 'urn:iso:std:iso:3166', 0),
    new Coding('JO', 'Jordan', 'urn:iso:std:iso:3166', 0),
    new Coding('JP', 'Japan', 'urn:iso:std:iso:3166', 0),
    new Coding('KE', 'Kenya', 'urn:iso:std:iso:3166', 0),
    new Coding('KG', 'Kyrgyzstan', 'urn:iso:std:iso:3166', 0),
    new Coding('KH', 'Cambodia', 'urn:iso:std:iso:3166', 0),
    new Coding('KI', 'Kiribati', 'urn:iso:std:iso:3166', 0),
    new Coding('KM', 'Comoros', 'urn:iso:std:iso:3166', 0),
    new Coding('KN', 'Saint Kitts and Nevis', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'KP',
      "Korea (Democratic People's Republic of)",
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('KR', 'Korea, Republic of', 'urn:iso:std:iso:3166', 0),
    new Coding('KW', 'Kuwait', 'urn:iso:std:iso:3166', 0),
    new Coding('KY', 'Cayman Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('KZ', 'Kazakhstan', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'LA',
      "Lao People's Democratic Republic",
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('LB', 'Lebanon', 'urn:iso:std:iso:3166', 0),
    new Coding('LC', 'Saint Lucia', 'urn:iso:std:iso:3166', 0),
    new Coding('LI', 'Liechtenstein', 'urn:iso:std:iso:3166', 0),
    new Coding('LK', 'Sri Lanka', 'urn:iso:std:iso:3166', 0),
    new Coding('LR', 'Liberia', 'urn:iso:std:iso:3166', 0),
    new Coding('LS', 'Lesotho', 'urn:iso:std:iso:3166', 0),
    new Coding('LT', 'Lithuania', 'urn:iso:std:iso:3166', 0),
    new Coding('LU', 'Luxembourg', 'urn:iso:std:iso:3166', 0),
    new Coding('LV', 'Latvia', 'urn:iso:std:iso:3166', 0),
    new Coding('LY', 'Libya', 'urn:iso:std:iso:3166', 0),
    new Coding('MA', 'Morocco', 'urn:iso:std:iso:3166', 0),
    new Coding('MC', 'Monaco', 'urn:iso:std:iso:3166', 0),
    new Coding('MD', 'Moldova, Republic of', 'urn:iso:std:iso:3166', 0),
    new Coding('ME', 'Montenegro', 'urn:iso:std:iso:3166', 0),
    new Coding('MF', 'Saint Martin (French part)', 'urn:iso:std:iso:3166', 0),
    new Coding('MG', 'Madagascar', 'urn:iso:std:iso:3166', 0),
    new Coding('MH', 'Marshall Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('MK', 'North Macedonia', 'urn:iso:std:iso:3166', 0),
    new Coding('ML', 'Mali', 'urn:iso:std:iso:3166', 0),
    new Coding('MM', 'Myanmar', 'urn:iso:std:iso:3166', 0),
    new Coding('MN', 'Mongolia', 'urn:iso:std:iso:3166', 0),
    new Coding('MO', 'Macao', 'urn:iso:std:iso:3166', 0),
    new Coding('MP', 'Northern Mariana Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('MQ', 'Martinique', 'urn:iso:std:iso:3166', 0),
    new Coding('MR', 'Mauritania', 'urn:iso:std:iso:3166', 0),
    new Coding('MS', 'Montserrat', 'urn:iso:std:iso:3166', 0),
    new Coding('MT', 'Malta', 'urn:iso:std:iso:3166', 0),
    new Coding('MU', 'Mauritius', 'urn:iso:std:iso:3166', 0),
    new Coding('MV', 'Maldives', 'urn:iso:std:iso:3166', 0),
    new Coding('MW', 'Malawi', 'urn:iso:std:iso:3166', 0),
    new Coding('MX', 'Mexico', 'urn:iso:std:iso:3166', 0),
    new Coding('MY', 'Malaysia', 'urn:iso:std:iso:3166', 0),
    new Coding('MZ', 'Mozambique', 'urn:iso:std:iso:3166', 0),
    new Coding('NA', 'Namibia', 'urn:iso:std:iso:3166', 0),
    new Coding('NC', 'New Caledonia', 'urn:iso:std:iso:3166', 0),
    new Coding('NE', 'Niger', 'urn:iso:std:iso:3166', 0),
    new Coding('NF', 'Norfolk Island', 'urn:iso:std:iso:3166', 0),
    new Coding('NG', 'Nigeria', 'urn:iso:std:iso:3166', 0),
    new Coding('NI', 'Nicaragua', 'urn:iso:std:iso:3166', 0),
    new Coding('NL', 'Netherlands', 'urn:iso:std:iso:3166', 0),
    new Coding('NO', 'Norway', 'urn:iso:std:iso:3166', 0),
    new Coding('NP', 'Nepal', 'urn:iso:std:iso:3166', 0),
    new Coding('NR', 'Nauru', 'urn:iso:std:iso:3166', 0),
    new Coding('NU', 'Niue', 'urn:iso:std:iso:3166', 0),
    new Coding('NZ', 'New Zealand', 'urn:iso:std:iso:3166', 0),
    new Coding('OM', 'Oman', 'urn:iso:std:iso:3166', 0),
    new Coding('PA', 'Panama', 'urn:iso:std:iso:3166', 0),
    new Coding('PE', 'Peru', 'urn:iso:std:iso:3166', 0),
    new Coding('PF', 'French Polynesia', 'urn:iso:std:iso:3166', 0),
    new Coding('PG', 'Papua New Guinea', 'urn:iso:std:iso:3166', 0),
    new Coding('PH', 'Philippines', 'urn:iso:std:iso:3166', 0),
    new Coding('PK', 'Pakistan', 'urn:iso:std:iso:3166', 0),
    new Coding('PL', 'Poland', 'urn:iso:std:iso:3166', 0),
    new Coding('PM', 'Saint Pierre and Miquelon', 'urn:iso:std:iso:3166', 0),
    new Coding('PN', 'Pitcairn', 'urn:iso:std:iso:3166', 0),
    new Coding('PR', 'Puerto Rico', 'urn:iso:std:iso:3166', 0),
    new Coding('PS', 'Palestine, State of', 'urn:iso:std:iso:3166', 0),
    new Coding('PT', 'Portugal', 'urn:iso:std:iso:3166', 0),
    new Coding('PW', 'Palau', 'urn:iso:std:iso:3166', 0),
    new Coding('PY', 'Paraguay', 'urn:iso:std:iso:3166', 0),
    new Coding('QA', 'Qatar', 'urn:iso:std:iso:3166', 0),
    new Coding('RE', 'Réunion', 'urn:iso:std:iso:3166', 0),
    new Coding('RO', 'Romania', 'urn:iso:std:iso:3166', 0),
    new Coding('RS', 'Serbia', 'urn:iso:std:iso:3166', 0),
    new Coding('RU', 'Russian Federation', 'urn:iso:std:iso:3166', 0),
    new Coding('RW', 'Rwanda', 'urn:iso:std:iso:3166', 0),
    new Coding('SA', 'Saudi Arabia', 'urn:iso:std:iso:3166', 0),
    new Coding('SB', 'Solomon Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('SC', 'Seychelles', 'urn:iso:std:iso:3166', 0),
    new Coding('SD', 'Sudan', 'urn:iso:std:iso:3166', 0),
    new Coding('SE', 'Sweden', 'urn:iso:std:iso:3166', 0),
    new Coding('SG', 'Singapore', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'SH',
      'Saint Helena, Ascension and Tristan da Cunha',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('SI', 'Slovenia', 'urn:iso:std:iso:3166', 0),
    new Coding('SJ', 'Svalbard and Jan Mayen', 'urn:iso:std:iso:3166', 0),
    new Coding('SK', 'Slovakia', 'urn:iso:std:iso:3166', 0),
    new Coding('SL', 'Sierra Leone', 'urn:iso:std:iso:3166', 0),
    new Coding('SM', 'San Marino', 'urn:iso:std:iso:3166', 0),
    new Coding('SN', 'Senegal', 'urn:iso:std:iso:3166', 0),
    new Coding('SO', 'Somalia', 'urn:iso:std:iso:3166', 0),
    new Coding('SR', 'Suriname', 'urn:iso:std:iso:3166', 0),
    new Coding('SS', 'South Sudan', 'urn:iso:std:iso:3166', 0),
    new Coding('ST', 'Sao Tome and Principe', 'urn:iso:std:iso:3166', 0),
    new Coding('SV', 'El Salvador', 'urn:iso:std:iso:3166', 0),
    new Coding('SX', 'Sint Maarten (Dutch part)', 'urn:iso:std:iso:3166', 0),
    new Coding('SY', 'Syrian Arab Republic', 'urn:iso:std:iso:3166', 0),
    new Coding('SZ', 'Eswatini', 'urn:iso:std:iso:3166', 0),
    new Coding('TC', 'Turks and Caicos Islands', 'urn:iso:std:iso:3166', 0),
    new Coding('TD', 'Chad', 'urn:iso:std:iso:3166', 0),
    new Coding('TF', 'French Southern Territories', 'urn:iso:std:iso:3166', 0),
    new Coding('TG', 'Togo', 'urn:iso:std:iso:3166', 0),
    new Coding('TH', 'Thailand', 'urn:iso:std:iso:3166', 0),
    new Coding('TJ', 'Tajikistan', 'urn:iso:std:iso:3166', 0),
    new Coding('TK', 'Tokelau', 'urn:iso:std:iso:3166', 0),
    new Coding('TL', 'Timor-Leste', 'urn:iso:std:iso:3166', 0),
    new Coding('TM', 'Turkmenistan', 'urn:iso:std:iso:3166', 0),
    new Coding('TN', 'Tunisia', 'urn:iso:std:iso:3166', 0),
    new Coding('TO', 'Tonga', 'urn:iso:std:iso:3166', 0),
    new Coding('TR', 'Turkey', 'urn:iso:std:iso:3166', 0),
    new Coding('TT', 'Trinidad and Tobago', 'urn:iso:std:iso:3166', 0),
    new Coding('TV', 'Tuvalu', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'TW',
      'Taiwan, Province of China [note 2]',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('TZ', 'Tanzania, United Republic of', 'urn:iso:std:iso:3166', 0),
    new Coding('UA', 'Ukraine', 'urn:iso:std:iso:3166', 0),
    new Coding('UG', 'Uganda', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'UM',
      'United States Minor Outlying Islands',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('US', 'United States of America', 'urn:iso:std:iso:3166', 0),
    new Coding('UY', 'Uruguay', 'urn:iso:std:iso:3166', 0),
    new Coding('UZ', 'Uzbekistan', 'urn:iso:std:iso:3166', 0),
    new Coding('VA', 'Holy See', 'urn:iso:std:iso:3166', 0),
    new Coding(
      'VC',
      'Saint Vincent and the Grenadines',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding(
      'VE',
      'Venezuela (Bolivarian Republic of)',
      'urn:iso:std:iso:3166',
      0,
    ),
    new Coding('VG', 'Virgin Islands (British)', 'urn:iso:std:iso:3166', 0),
    new Coding('VI', 'Virgin Islands (U.S.)', 'urn:iso:std:iso:3166', 0),
    new Coding('VN', 'Viet Nam', 'urn:iso:std:iso:3166', 0),
    new Coding('VU', 'Vanuatu', 'urn:iso:std:iso:3166', 0),
    new Coding('WF', 'Wallis and Futuna', 'urn:iso:std:iso:3166', 0),
    new Coding('WS', 'Samoa', 'urn:iso:std:iso:3166', 0),
    new Coding('YE', 'Yemen', 'urn:iso:std:iso:3166', 0),
    new Coding('YT', 'Mayotte', 'urn:iso:std:iso:3166', 0),
    new Coding('ZA', 'South Africa', 'urn:iso:std:iso:3166', 0),
    new Coding('ZM', 'Zambia', 'urn:iso:std:iso:3166', 0),
    new Coding('ZW', 'Zimbabwe', 'urn:iso:std:iso:3166', 0),
  ],
);

const yesNo = new ValueSet(
  'http://lifeomic.com/fhir/valueset/yesno',
  'Yes/No',
  'survey-list',
  [
    new Coding('Y', 'Yes', 'http://lifeomic.com/fhir/valueset/yesno', 0),
    new Coding('N', 'No', 'http://lifeomic.com/fhir/valueset/yesno', 0),
  ],
);

export { uspsStates, iso3166CountryCodes, yesNo };
